import { render, staticRenderFns } from "./project-inventory-faq.vue?vue&type=template&id=1229cbac&scoped=true&"
import script from "./project-inventory-faq.vue?vue&type=script&lang=js&"
export * from "./project-inventory-faq.vue?vue&type=script&lang=js&"
import style0 from "./project-inventory-faq.vue?vue&type=style&index=0&id=1229cbac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229cbac",
  null
  
)

export default component.exports